<template>
  <div class='indexbox'>
    <div class="searchbox">
    </div>
    <div class="tablebox">
      <div class="draggable" v-loading='loading'>
        <el-form ref="form" :model="info" label-position="right" label-width="300px">
          <el-form-item :label="$t('lg.管理员邮箱')">
            <el-input v-model="info.email" readonly></el-input>
          </el-form-item>
          <el-form-item :label="$t('lg.绑定时间')">
            <el-input v-model="info.create_time" readonly></el-input>
          </el-form-item>
          <el-form-item :label="`DEAR${$t('lg.组织名称')}`">
            <el-input v-model="info.company" readonly></el-input>
          </el-form-item>
          <el-form-item label="API Account">
            <el-input v-model="info.api_account" readonly></el-input>
          </el-form-item>
          <el-form-item label="API Key">
            <el-input v-model="info.api_key" readonly></el-input>
          </el-form-item>
          <el-form-item :label="`OMS${$t('lg.订阅到期日')}`">
            <el-input v-model="info.end_time" readonly></el-input>
          </el-form-item>
          <el-form-item :label="$t('lg.订阅订单量')">
            <el-input v-model="info.order_num" readonly></el-input>
          </el-form-item>
          <el-form-item :label="$t('lg.已用订单量')">
            <el-input v-model="info.has_num" readonly></el-input>
          </el-form-item>
          <el-form-item :label="$t('lg.剩余订单量')">
            <el-input v-model="info.remain_num" readonly></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
    },
    data() {
      return {
        loading: false,
        info: {},
      };
    },
    methods: {
      lookdata() {
        this.loading = true
        this.$post({
          url: "/app/member_api/apiInfo",
          data: {
            id: this.api_id
          },
          success: (res) => {
            this.info = res.data
            this.loading = false
          },
          tip: () => {
            this.loading = false
          },
        })
      },
    },
    created() {
      this.lookdata()
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      padding: 10px 20px 0px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      /deep/.el-row {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .right {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
      /deep/.el-form {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-form-item {
          margin: 0 20px 10px 0 !important;
        }
      }
    }
    .tablebox {
      width: 100%;
      padding: 20px;
      .draggable {
        width: 100%;
        background: #fff;
        padding: 10px;
        border-radius: 10px;
      }
    }
  }
</style>